export const FORTNOX_INIT = 'FORTNOX_INIT';
export const COMPLETE_AUTH = 'COMPLETE_AUTH';
